import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import LeiService from '../../../../../services/leis-auth';
import { Link, useParams, Navigate } from 'react-router-dom';
import Moment from 'moment';






const Lei = () => {
    let { id } = useParams()

    const [numLei, setNumLei] = useState("");
    const [letra, setLetra] = useState("");
    const [dataLei, setDataLei] = useState("");
    const [dataPub, setDataPub] = useState("");
    const [ano, setAno] = useState("");
    const [categoria, setCategoria] = useState("");
    const [ementa, setEmenta] = useState("");
    const [jornal, setJornal] = useState("");
    const [error, setError] = useState([]);
    const [sucesso, setSucesso] = useState(false);
  
    async function fetchLei(id) {
        const response = await LeiService.leiEdit(id);
            Moment.locale();
            setNumLei(response.data["num_lei"]);
            setLetra(response.data["letra"]);
            setDataLei(Moment(response.data["data_lei"]).utc(false).format("yyyy-MM-DD"));
            setDataPub(Moment(response.data["data_p"]).utc(false).format("yyyy-MM-DD"));
            setAno(response.data["ano"]);
            setCategoria(response.data["categoria"]);
            setEmenta(response.data["ementa"]);
            setJornal(response.data["jornal"]);
    }

    useEffect(() => {
        fetchLei(id);
    }, [id]);


    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const lei = await LeiService.editar(id, {
                numero: numLei,
                letra: letra,
                data_lei: dataLei,
                data_publicacao: dataPub,
                ano: ano,
                categoria: categoria,
                ementa: ementa,
                jornal: jornal
            })
            if (lei.data["cod_lei"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }


    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={4}>
                        <Col>
                            <Form.Group className="mb-3" controlId="NumLei">
                                <FloatingLabel
                                    label="Número da Lei"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="num_lei"
                                        value={numLei}
                                        onChange={e => setNumLei(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Letra">
                                <FloatingLabel
                                    label="Letra da Lei"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Letra"
                                        name="letra"
                                        onChange={e => setLetra(e.target.value)}
                                    >
                                        {letra ? <option value={letra}>{letra}</option> : <option>NENHUMA</option>}
                                        <option value="A">A</option>
                                        <option value="B">B</option>
                                        <option value="C">C</option>
                                        <option value="D">D</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="DataLei">
                                <FloatingLabel
                                    label="Data da Lei"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="data_lei"
                                        value={dataLei}
                                        onChange={e => setDataLei(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="DataPub">
                                <FloatingLabel
                                    label="Data da Publicação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="dataPub"
                                        value={dataPub}
                                        onChange={e => setDataPub(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row xs={1} lg={3}>
                        <Col>
                            <Form.Group className="mb-3" controlId="Ano">
                                <FloatingLabel
                                    label="Ano"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Ano"
                                        name="ano"
                                        onChange={e => setAno(e.target.value)}
                                    >
                                        <option value={ano}>{ano}</option>
                                        <option value="2025">2025</option>
                                        <option value="2024">2024</option>
                                        <option value="2023">2023</option>
                                        <option value="2022">2022</option>
                                        <option value="2021">2021</option>
                                        <option value="2020">2020</option>
                                        <option value="2019">2019</option>
                                        <option value="2018">2018</option>
                                        <option value="2017">2017</option>
                                        <option value="2016">2016</option>
                                        <option value="2015">2015</option>
                                        <option value="2014">2014</option>
                                        <option value="2013">2013</option>
                                        <option value="2012">2012</option>
                                        <option value="2011">2011</option>
                                        <option value="2010">2010</option>
                                        <option value="2009">2009</option>
                                        <option value="2008">2008</option>
                                        <option value="2007">2007</option>
                                        <option value="2006">2006</option>
                                        <option value="2005">2005</option>
                                        <option value="2004">2004</option>
                                        <option value="2003">2003</option>
                                        <option value="2002">2002</option>
                                        <option value="2001">2001</option>
                                        <option value="2000">2000</option>
                                        <option value="1999">1999</option>
                                        <option value="1998">1998</option>
                                        <option value="1997">1997</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Categoria">
                                <FloatingLabel
                                    label="Categoria"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Categoria"
                                        name="categoria"
                                        onChange={e => setCategoria(e.target.value)}
                                    >
                                        <option value={categoria}>{categoria}</option>
                                        <option value="Lei Municipal">Lei Municipal</option>
                                        <option value="Lei Tributária">Lei Tributária</option>
                                        <option value="Lei Orçamentária">Lei Orçamentária</option>
                                        <option value="Lei de Transparência">Lei de Transparência</option>
                                        <option value="Lei Orçamentária Anual - LOA">Lei Orçamentária Anual - LOA</option>
                                        <option value="Lei Orçamentária Plurianual - PPA">Lei Orçamentária Plurianual - PPA</option>
                                        <option value="Lei de Diretrizes Orçamentárias - LDO">Lei de Diretrizes Orçamentárias - LDO</option>
                                        <option value="Decreto">Decretos</option>
                                        <option value="Portaria">Portarias</option>
                                        <option value="Indicação">Indicações</option>
                                        <option value="Lei Ordinária">Lei Ordinária</option>
                                        <option value="Lei Complementar">Lei Complementar</option>
                                        <option value="Lei de Vigilância Sanitária">Lei de Vigilância Sanitária</option>
                                        <option value="Resolução">Resoluções</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group className="mb-3" controlId="Jornal">
                                <FloatingLabel
                                    label="Jornal"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Jornal"
                                        name="jornal"
                                        onChange={e => setJornal(e.target.value)}
                                    >
                                        <option value={jornal}>{jornal}</option>
                                        <option value="">Nenhum</option>
                                        <option value="O Sol">O Sol</option>
                                        <option value="Manchetes">Manchetes</option>
                                        <option value="O Fluminense">O Fluminense</option>
                                        <option value="O Centro Norte">O Centro Norte</option>
                                        <option value="O Momento">O Momento</option>
                                        <option value="O Macuco">O Macuco</option>
                                        <option value="Tribuna da Serra">Tribuna da Serra</option>
                                        <option value="da Região">da Região</option>
                                        <option value="Gazeta de Cordeiro">Gazeta de Cordeiro</option>
                                        <option value="Diário Oficial de Macuco">Diário Oficial de Macuco</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>

                    <Row xs={1} lg={2}>
                        <Col lg={12}>
                            <Form.Group className="mb-3" controlId="ementa">
                                <FloatingLabel
                                    label="Ementa"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="textarea"
                                        name="ementa"
                                        value={ementa}
                                        onChange={e => setEmenta(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/leis/listar'}>
                    <Button variant="danger" type="button">
                        Cancelar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Lei editada com sucesso!</Alert>
                <Navigate to={'/restrito/leis/listar'} />
            </Fragment>
        )
    }
}

export default Lei;